import React from 'react';

import HandsRaisedIcon from '../assets/hands_raised.svg';
import MapIcon from '../assets/map.svg';

const infoSections = [
  {
    icon: <img src={MapIcon} alt="Map showing a path to follow" />,
    name: 'Over 1300+ Official TOEFL® Questions',
    text: "Our self-paced TOEFL® prep course includes over 1300 TOEFL® practice questions used under license from ETS, the makers of the test, so you know you're studying exactly what you'll see on test day."
  },
  {
    icon: <img src={HandsRaisedIcon} alt="Hands raised in the air" />,
    name: 'Improve Your TOEFL Score, Guaranteed!',
    text: 'Magoosh has graded writing assignments, full-length practice tests, expert video lessons, custom study schedules and more.'
  }
];

export default { infoSections };
